export default {
    currentPassword: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
          maximum: 128
        }
    },
    newPassword: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
          maximum: 128
        }
    },
    confirmNewPassword: {
        presence: { allowEmpty: false, message: 'is required' },
        equality: "newPassword"
    },
};